






































import { Component, Vue, Emit } from 'vue-property-decorator';
import { institutionServer, patrolManagementServe } from '@/api/installServer';

@Component
export default class PatrolEquipEdit extends Vue {
  private visible = false;
  private showMacAddress = false;
  private type = '';

  private companyData: any = []; // 单位列表
  private spaceId: any = []; // 单位列表

  private form: any = {
    id: '',
    type: '',
    label: '',
    code: '',
    macAddress: '',
    uuId: '',
    pointName: '',
    pointId: '',
    spaceId: '',
  };
  private equipData: any = {};
  private pointList: any = [];
  private equipRules: any = {
    code: [{ required: true, message: '设备编码', trigger: 'blur' }],
    // code: [{required: true, message: '设备编码', trigger: 'blur', validator: this.myValidate("code")}],
    type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
    // macAddress: [{required: this.showMacAddress, message: '请输入MAC地址', trigger: 'blur', validator: this.myValidate("macAddress")}],
  };
  private equipRulesResult: any = {
    code: '',
    type: '',
    macAddress: '',
    uuId: '',
  };
  private typeOptions: any = [
    {
      value: '1',
      label: '二维码',
      showMacAddress: false,
    },
    {
      value: '2',
      label: '蓝牙',
      showMacAddress: true,
    },
    {
      value: '3',
      label: '蓝牙+二维码',
      showMacAddress: true,
    },
  ];

  /**
   * 【接口】获取单位列表
   */
  private getCompanyDataList() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        if (res.code === '200') {
          this.companyData = res.data;
        } else {
          this.$message.warning('获取数据失败，请稍后重试！');
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败，请稍后重试！');
      });
  }

  spaceChange(e: any) {
    if (this.form.type) {
      this.getPointListAll({ spaceId: e });
    }
    this.form.pointId = '';
  }

  created() {
    // this.getPointListAll({});
  }

  /**
   * 窗口标题
   */
  get title() {
    const typeMap: any = {
      add: '添加巡检设备',
      edit: '修改巡检设备',
    };
    return typeMap[this.type];
  }

  /**
   * 打开新增窗口
   */
  async showAddDialog() {
    this.type = 'add';
    this.getCompanyDataList();
    this.clearForm();
    this.visible = true;
  }

  /**
   * 打开编辑窗口
   */
  async showEditDialog(data: any) {
    this.type = 'edit';
    this.getCompanyDataList();
    this.form = data;
    this.equipData = data;
    try {
      await this.handleTypeChange();
      this.visible = true;
    } catch (e) {}
  }

  /**
   * 修改类型时，同时更新巡检点
   */
  async handleTypeChange() {
    this.form.pointId = '';
    try {
      // if (this.spaceId) {
      //   await this.getPointListAll();
      // }
      await this.getPointListAll({ spaceId: this.form.spaceId });
      this.isShowMacAddressInput();
      this.equipRulesChangeRequired('macAddress', this.showMacAddress);
    } catch (e) {}
  }

  /**
   * 关闭窗口
   */
  hideDialog() {
    this.equipData = {};
    this.resetForm();
    this.visible = false;
  }

  /**
   * 【按钮】提交按钮点击
   */
  handleSubmitBtnClick() {
    // console.log(this.equipRules)
    this.checkPointBind();
  }

  /**
   * 【显示条件】是否显示MAC地址的输入框
   */
  isShowMacAddressInput() {
    try {
      const arrObj = this.typeOptions;
      arrObj.forEach((item: any) => {
        if (this.form.type == item.value) {
          this.showMacAddress = item.showMacAddress;
          throw new Error();
        }
      });
    } catch (e) {}
  }

  /**
   * 巡检设备form的规则，发生改变
   */
  equipRulesChangeRequired(key: string, value: any) {
    this.equipRules[key][0].required = value;
  }

  /**
   * 提交
   */
  handleSubmit() {
    // console.log(this.equipRules);
    const formComponent: any = this.$refs['form'];
    formComponent.validate;
    formComponent.validate((valid: any) => {
      if (!valid) return;
      switch (this.type) {
        case 'add':
          this.addEquipData();
          break;
        case 'edit':
          this.editEquipData();
          break;
      }
    });
  }

  /**
   *【表单】表单重置
   */
  resetForm() {
    const formComponent: any = this.$refs['form'];
    formComponent.resetFields();
  }

  /**
   *【表单】表单赋值
   * @params data
   */
  assignDataToForm(data: any) {
    this.form = {
      ...this.form,
      ...{
        type: data.type,
        label: data.label,
        code: data.code,
        pointName: data.pointName,
        pointId: data.pointId,
      },
    };
    // console.log('表单赋值:' + this.form.type);
  }

  /**
   * 清空表单
   */
  clearForm() {
    this.form = {
      type: '',
      label: '',
      code: '',
      pointName: '',
      pointId: '',
    };
  }

  /**
   * 检查巡检点是否被绑定
   */
  checkPointBind() {
    const arrObj = this.pointList;
    try {
      arrObj.forEach((item: any) => {
        if (item.pointId == this.form.pointId) {
          if (item.bindStatus == '绑定') {
            this.$confirm('该巡检点已经被绑定,是否从原来绑定的设备上解除绑定，重新绑定现在的设备?', '警告', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
            })
              .then(() => {
                this.handleSubmit();
              })
              .catch(() => {});
          } else {
            this.handleSubmit();
          }
          throw new Error();
        }
      });
      this.handleSubmit();
    } catch (e) {}
  }

  /**
   * 【接口】添加巡检设备
   */
  async addEquipData() {
    try {
      const res: any = await patrolManagementServe.addPatrolEquip({
        type: this.form.type,
        code: this.form.code,
        pointId: this.form.pointId,
        macAddress: this.form.macAddress,
        uuId: this.form.uuId,
      });
      if (res.code === '201') {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功添加了记录。');
      } else if (res.code == 422) {
        this.$message.warning(res.msg);
        throw new Error();
      } else {
        this.$message.warning('新增失败');
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】修改巡检设备
   */
  async editEquipData() {
    try {
      const res: any = await patrolManagementServe.editPatrolEquipData(this.equipData.id, {
        type: this.form.type,
        code: this.form.code,
        pointId: this.form.pointId,
        macAddress: this.form.macAddress,
        uuId: this.form.uuId,
      });
      // console.log(res.code);
      if (res.code == 201) {
        this.hideDialog();
        this.onResponse();
        this.$message.success('您成功修改了记录。');
      } else if (res.code) {
        this.$message.warning(res.msg);
        throw new Error();
      } else {
        this.$message.warning('修改失败');
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 【接口】获取巡检点list
   */
  async getPointListAll(opts: object) {
    try {
      const res: any = await patrolManagementServe.getPatrolEquipPointAllData(this.form.type, opts);
      if (res.code === '200') {
        this.pointList = res.data;
      } else {
        this.$message.warning('网络异常，请稍后重试。');
        throw new Error();
      }
    } catch (e) {
      throw new Error();
    }
  }

  /**
   * 提交成功事件
   * @Params
   * @return
   **/
  @Emit('on-response')
  onResponse() {}
}
